module.exports = __webpack_public_path__ + "img/mf.571a0711.svg";